<template>
  <div>
    <v-menu
      offset-y
      :close-on-content-click="false"
      rounded="t-lg b-lg"
      max-width="350"
      min-width="350"
      left
      @input="isClose"
    >
      <!-- TODO Notification Buttom  -->
      <template v-slot:activator="{ on, attrs }">
        <div>
          <v-badge
            v-if="items.length > 0 && items.length <= 99"
            bottom
            color="error"
            offset-x="25"
            offset-y="45"
            :content="limit"
          >
            <v-btn icon color="primary" @click="show" v-bind="attrs" v-on="on">
              <v-icon>mdi-bell-outline</v-icon>
            </v-btn>
          </v-badge>
          <v-badge
            v-else-if="items.length > 0 && items.length > 99"
            bottom
            color="error"
            offset-x="25"
            offset-y="45"
            content="99+"
          >
            <v-btn icon color="primary" @click="show" v-bind="attrs" v-on="on">
              <v-icon>mdi-bell-outline</v-icon>
            </v-btn>
          </v-badge>
          <v-btn icon v-else v-bind="attrs" v-on="on" disabled>
            <v-icon>mdi-bell-outline</v-icon>
          </v-btn>
        </div>
      </template>

      <!-- TODO Content Notification -->
      <div class="layout-notification-layout">
        <v-card class="pa-0">
          <u-infinity-scroll
            v-model="items"
            :limit.sync="limit"
            :increase.sync="increase"
            :current.sync="current"
            itemKey="id"
            :loading="limit > increase"
            @endPage="GetData"
            maxHeight="60vh"
          >
            <template v-slot:body="{ item }">
              <div class="pa-0">
                <!-- <v-alert
                  text
                  dense
                  :type="alertColor(item.type, item.state)"
                  border="left"
                  elevation="1"
                  class="ma-0 notification-alert"
                >
                  <div class="d-flex">
                    <span class="notification-title text-uppercase pr-3">
                      {{ item.title }}
                    </span>
                    <v-spacer></v-spacer>
                    <div>
                      <v-btn
                        color="primary"
                        outlined
                        small
                        @click="Close(item.notification_id)"
                      >
                        อ่านแล้ว
                      </v-btn>
                    </div>
                  </div>
                  <div class="notification-message">
                    {{ item.message }}
                  </div>
                  <div class="notification-create-by">By : {{ item.name }}</div>
                  <span class="notification-time"
                    >{{ item.create_date | moment }}
                  </span>
                </v-alert> -->

                <nc
                  :item="item"
                  :color="alertColor(item.type, item.state)"
                  :type="alertColor(item.type, item.state)"
                ></nc>
              </div>
            </template>
          </u-infinity-scroll>
        </v-card>
      </div>
    </v-menu>
  </div>
</template>

<script>
import nc from '../NotificationCard.vue'
export default {
  components: {
    nc
  },
  data () {
    return {
      audio: new Audio(require('@/assets/sounds/computerwav-14702.mp3')),
      notifications: [],
      selected: [],
      showMenu: false,
      x: 0,
      y: 0,
      items: [],
      limit: 0,
      increase: 6,
      current: 1,

      statusRead: false
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.$websocket.$on('notification', (e) => {
      this.audio.pause()
      const arr = [e, ...this.items]
      this.items = arr
      this.limit += 1
      this.audio.play()
    })

    this.$websocket.$on('logout', (e) => {
      this.$websocket.Disconnect()
      localStorage.clear()
      this.$swal({
        allowOutsideClick: false,
        allowEnterKey: false,
        title: 'มีการ Login เข้าใช้งานจากเครื่องอื่น',
        text: 'กรุณา Login เพื่อเข้าใช้งานใหม่อีกครั้ง',
        icon: 'warning',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$vuetify.theme.dark = false
          this.OauthLogOutOneID()
          // this.$router.push({ name: 'loginPage' }).catch(() => {})
        }
      })
    })
  },
  methods: {
    async GetData () {
      await this.init()
    },

    isClose (v) {
      if (v) {
        // TODO Open
        this.statusRead = true
        this.items.forEach((i) => {
          this.ReadNotification(i.notification_id)
        })
      } else {
        // TODO Close
        this.statusRead = false
        this.$nextTick(() => {
          setTimeout(() => {
            this.items = Object.assign([])
            this.current = 1
            this.init()
          }, 150)
        })
      }
    },

    async init () {
      this.loading = true
      // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
      const payload = {
        page: this.current,
        row: this.increase,
        keyword: '',
        read: 'false'
      }
      const res = await this.getNotificationForTable(payload)
      this.loading = false
      if (res.status) {
        this.limit = res.data.pagination.total
        this.items = this.items.concat(res.data.data)
        if (this.statusRead) {
          res.data.data.forEach((i) => {
            this.ReadNotification(i.notification_id)
          })
        }
      } else {
        this.antmessage.error(res.message)
      }
    },

    show (e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },

    alertColor (type, state) {
      if (type === 'news' || type === 'approve_hospital_user') {
        return 'info'
      } else if (type === 'alert') {
        if (state === 0) {
          return 'success'
        } else if (state === 1) {
          return 'info'
        } else if (state === 2) {
          return 'warning'
        } else if (state === 3) {
          return 'error'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-notification-layout {
  // width: 500px;
  // height: 50vh !important;
  // height: auto !important;
  // max-height: 50vh !important;
  overflow: none !important;
  padding: 0px;
  // background: red !important;
}

.detail-noti {
  font-size: 14px;
  font-weight: 300;
}
.detail-noti-by {
  font-size: 12px;
  font-weight: 300;
  color: var(--v-tprimary-base);
}
.notification-alert {
  width: 100%;
}

.notification-title {
  font-size: 18px;
  font-weight: 600;
}

.notification-time {
  font-size: 11px;
  font-weight: 300;
  line-height: 2.5em;
}

.notification-message {
  font-size: 14px;
  font-weight: 300;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: var(--v-tprimary-base);
}

.notification-create-by {
  font-size: 12px;
  font-weight: 300;
  color: var(--v-tprimary-base);
}
</style>
